import * as React from "react";

const SpeakerIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <g
      stroke="#C3DEFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_334_7203)"
    >
      <path d="M7.5 15.75H3a.75.75 0 0 1-.75-.75V9A.75.75 0 0 1 3 8.25h4.5L14.25 3v18zM7.5 8.25v7.5M18 10.016a3 3 0 0 1 0 3.965M20.782 7.5a6.75 6.75 0 0 1 0 9"></path>
    </g>
    <defs>
      <clipPath id="clip0_334_7203">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SpeakerIcon;
